import * as React from "react";
import AppointmentErrorContainer from "../../../../../../../../../components/AppointmentError/v3/components/AppointmentError/AppointmentErrorContainer.js";
import { appointmentErrors } from "../../../../../../../../../utils/v3/utils/appointments.js";
import CancelAppointmentContainer from "./CancelAppointmentContainer.js";
import CancelAppointmentRootWithMyAccountEnabled from "./CancelAppointmentRootWithUserToken.js";
import { useCancelAppointmentContext } from "../../../../../../../context/v3/pages/CancelAppointment/context/context.js";
const CancelAppointmentRoot = () => {
  const {
    config: { appointmentId, token, bookAppointmentUrl }
  } = useCancelAppointmentContext();
  if (appointmentId) {
    return /* @__PURE__ */ React.createElement(CancelAppointmentRootWithMyAccountEnabled, { appointmentId });
  }
  if (token) {
    return /* @__PURE__ */ React.createElement(CancelAppointmentContainer, { token });
  }
  return /* @__PURE__ */ React.createElement(
    AppointmentErrorContainer,
    {
      status: appointmentErrors[0],
      bookAppointmentUrl
    }
  );
};
export {
  CancelAppointmentRoot as default
};
//# sourceMappingURL=CancelAppointmentRoot.js.map
